import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/NoText/components/ImagesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/NoText/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/Short/components/ImagesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/Short/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/Text/components/ImagesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/portfolio/[id]/components/Text/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/projects/List/components/SeeMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/components/ui/slider.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
